module.exports = __webpack_public_path__ + "img/bg-3.9ddfc7f4.jpg";